import React from "react";
import { styled } from "../../../stitches.config";

import Home from "../../../config/natemat/assets/home.svg";
import Link from "../../../components/Link";


const DomainLogo: React.FC = () => {

    const domainLogoUrl = window?.APP_SETTINGS?.domain_settings?.logo_url
    const domainName = window?.APP_SETTINGS?.domain_settings?.service_name
    const mainDomainUrl = window?.APP_SETTINGS?.main_domain

    const normalizedUrl = mainDomainUrl.startsWith("http")
        ? mainDomainUrl
        : `https://${mainDomainUrl}`

    return (
        <LogoWrapper className="navigation-top--logo">
            <a href={normalizedUrl}>
                <HomeLogo src={Home} alt="Home" />
            </a>
            <Link to={"/"}>
                <DomainLogoImg src={domainLogoUrl} alt={domainName || "Logo"} />
            </Link>
        </LogoWrapper>
    );

};


const LogoWrapper = styled("div", {
    height: 52,
    display: "flex",
    alignItems: "center",
    width: "auto",
    justifyContent: "flex-start",
    padding: "0 20px 0 0 ",
    marginTop: '3px',

    "@bp4": {
        marginLeft: "0px",
        //minWidth: 192,
        height: 60,
        padding: "0 40px",
    },

    "a": {
        display: "flex",
        alignItems: "center",
    }
})

const HomeLogo = styled("img", {
    height: "20px",
    width: "auto",
    marginRight: "6px",
    objectFit: "contain",
    transition: "0.3s",
    marginBottom: "6px",

    "@bp4": {
        height: "24px",
        //marginBottom: "4px",
    },

    "&:hover": {
        opacity: "0.7",
    }
})

const DomainLogoImg = styled("img", {
    height: "20px",
    objectFit: "contain",
    transition: "0.3s",
    //marginTop: "2px",

    "@bp4": {
        height: "24px",
        //marginTop: "4px",
    },

    "&:hover": {
        opacity: "0.7",
    }
})

export default DomainLogo;